import { MemoryRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import MainPage from './pages/main';
import QuestionsPage from './pages/questions';
import SimulatePage from './pages/simulation';
import TestProvider from './TestProvider';

const tester = new TestProvider();

export default function App() {
  return (
    <Router initialEntries={['/']} initialIndex={1}>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route
          path="/language"
          element={
            <QuestionsPage
              category="language"
              questions={tester.getLanguage()}
            />
          }
        />
        <Route
          path="/history"
          element={
            <QuestionsPage category="history" questions={tester.getHistory()} />
          }
        />
        <Route
          path="/law"
          element={<QuestionsPage category="law" questions={tester.getLaw()} />}
        />
        <Route
          path="/simulate"
          element={<SimulatePage test={tester.simulation()} />}
        />
      </Routes>
    </Router>
  );
}
